import * as UserActionService from "../user-action-service";

const CATEGORY_PAPER = "Paper";
const ACTION_APPROVED = "Approved";
const ACTION_REJECTED = "Rejected";

export function trackPaperApproval(approved, paperId) {

    let text;
    if (approved) {
        text = ACTION_APPROVED + " " + paperId;
    } else {
        text = ACTION_REJECTED + " " + paperId;
    }

    UserActionService.sendAction(CATEGORY_PAPER, text);
}